module.exports = __webpack_public_path__ + "img/congratulations.a1b02d24.svg";